// extracted by mini-css-extract-plugin
export default {"logo":"header_logo__wLirW","autoHide":"header_autoHide__GkKPP","hidden":"header_hidden__gbYee"};